import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";
import { Mail, Globe, Building2 } from "lucide-react";

export default function Contact() {
  return (
    <LegalLayout
      testid="page-contact"
      eyebrow="Get in touch"
      title="Contact ForgedOps"
      intro="For sales, security inquiries, support, partnerships, or media — reach the ForgedOps team using the channels below. We respond during normal U.S. Eastern business hours."
      metaTitle="Contact · ForgedOps Plans"
      metaDescription="Contact ForgedOps LLC — sales, security, support, partnerships. info@forgedopshq.com · https://forgedopshq.com."
      canonical="https://forgedopsplans.com/contact"
    >
      <section
        className="not-prose grid sm:grid-cols-2 gap-4"
        data-testid="contact-cards"
      >
        <ContactCard
          icon={Building2}
          label="Company"
          primary="ForgedOps LLC"
          testid="contact-card-company"
        />
        <ContactCard
          icon={Mail}
          label="Email"
          primary={
            <a
              href="mailto:info@forgedopshq.com"
              className="underline underline-offset-2"
              style={{ color: "var(--fop-primary)" }}
              data-testid="contact-email-link"
            >
              info@forgedopshq.com
            </a>
          }
          testid="contact-card-email"
        />
        <ContactCard
          icon={Globe}
          label="Web"
          primary={
            <a
              href="https://forgedopshq.com"
              target="_blank"
              rel="noreferrer noopener"
              className="underline underline-offset-2"
              style={{ color: "var(--fop-primary)" }}
              data-testid="contact-web-link"
            >
              forgedopshq.com
            </a>
          }
          testid="contact-card-web"
        />
        <ContactCard
          icon={Mail}
          label="Security inquiries"
          primary={
            <a
              href="mailto:info@forgedopshq.com"
              className="underline underline-offset-2"
              style={{ color: "var(--fop-primary)" }}
              data-testid="contact-security-link"
            >
              info@forgedopshq.com
            </a>
          }
          secondary="Use the email above for vulnerability reports, security questionnaires, and compliance requests."
          testid="contact-card-security"
        />
      </section>
    </LegalLayout>
  );
}

function ContactCard({ icon: Icon, label, primary, secondary, testid }) {
  return (
    <div
      className="rounded-md border p-5"
      style={{
        borderColor: "var(--fop-border)",
        background: "var(--fop-surface)",
      }}
      data-testid={testid}
    >
      <div className="flex items-center gap-2 mb-2">
        <Icon size={16} style={{ color: "var(--fop-primary)" }} />
        <div
          className="font-mono text-[10px] uppercase tracking-[0.25em]"
          style={{ color: "var(--fop-text-3)" }}
        >
          {label}
        </div>
      </div>
      <div
        className="text-lg font-display"
        style={{ color: "var(--fop-text)" }}
      >
        {primary}
      </div>
      {secondary && (
        <div
          className="text-sm mt-2 leading-relaxed"
          style={{ color: "var(--fop-text-2)" }}
        >
          {secondary}
        </div>
      )}
    </div>
  );
}
